import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

export type BvAlertVariant =
  | "info"
  | "success"
  | "warning"
  | "error"
  | "brand";

/**
 * Banner-style alert. Mirrors design-system.html .alert.
 *
 *   <bv-alert variant="success">Saved.</bv-alert>
 *   <bv-alert variant="error">
 *     <bv-icon name="error_outline" size="sm"></bv-icon>
 *     Couldn't save — try again.
 *   </bv-alert>
 */
@Component({
    selector: "bv-alert",
    template: "<ng-content></ng-content>",
    styleUrls: ["./alert.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "bv-alert",
        "role": "alert",
        "[class.bv-alert--info]": 'variant === "info"',
        "[class.bv-alert--success]": 'variant === "success"',
        "[class.bv-alert--warning]": 'variant === "warning"',
        "[class.bv-alert--error]": 'variant === "error"',
        "[class.bv-alert--brand]": 'variant === "brand"',
    }
})
export class BvAlertComponent {
  @Input() variant: BvAlertVariant = "info";
}
